<!-- This modal opens on clicking the 'Upload History' button under table 'Actions' -->
<template>
  <div>
    <b-modal
      id="uploadHistoryModal"
      size="xl"
      visible
      ok-only
      ok-title="Close"
      title="Upload History"
      @hide="$emit('close')"
    >
      <div>
        <UploadHistoryTable :table-ids="tableIds" />
      </div>
      <content-spinner
        :show="uploadHistoryLoadingState"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import UploadHistoryTable from './components/UploadHistoryTable.vue';
import ContentSpinner from '@/core/components/ContentSpinner.vue';

const {
  mapState: uploadHistoryMapState, 
  mapActions: uploadHistoryMapActions,
} = createNamespacedHelpers('dataManagement');

export default {
  name: 'UploadHistory',
  props: {
    tableIds: Array,
  },
  components: {
    UploadHistoryTable,
    ContentSpinner,
  },
  computed: {
    ...uploadHistoryMapState({
      uploadHistoryLoadingState: state => state.uploadHistory.loading,
    }),
  },
  methods: {
    ...uploadHistoryMapActions(['updateUploadHistoryLoading']),
  },
  mounted() {
    this.updateUploadHistoryLoading();
  },
};
</script>